import Vue from "vue";
// Remplaza un string por formato de moneda
Vue.filter("currency", function(num) {
  return "$ " + num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1.");
});
Vue.prototype.$filters = Vue.options.filters;
